"use strict";

import { homeConstants, commonConstants, responseCodes } from "../_constants";

export const INITIAL_HOME_STATE = {
    rewordRecipients: [],
    campaigns: [],
    reasonsForIssuance: [],
    code: "",
    campaignsList: [],
    campaingDetails: {},
    chatMessageList:[],
    faqList:[],
    participantJobRoles: [],
    dealerParticipant: [],
    gamePlayDetails:[],
    notification:[],
    notificationCount:0
};

export function home(state = INITIAL_HOME_STATE, action) {
    switch (action.type) {
        case homeConstants.HOME_GET_PARTICIPANT_LIST_COMPLETE:
            return {
                ...state,
                rewordRecipients: [...action.payload.data],
            };

        case homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_COMPLETE:
            return {
                ...state,
                campaingDetails: { ...action.payload.data },
            };

        case homeConstants.HOME_CLEAR:
            return {
                ...state,
                campaingDetails: {},
            };

        case homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_COMPLETE:
            return {
                ...state,
                reasonsForIssuance: [...action.payload.data],
            };

        case homeConstants.HOME_GET_REALTIME_REWARD_CODE_COMPLETE:
            return {
                ...state,
                code: action.payload.data,
            };

        case homeConstants.HOME_CAMPAIGN_LIST_COMPLETE:
            return {
                ...state,
                campaignsList: [...action.payload.data],
            };

        case homeConstants.HOME_SMS_REALTIME_REWARD_CODE_COMPLETE:
            return {
                ...state,
                code: "",
            };

        case homeConstants.HOME_CHATBOT_REPLY_QUESTION_COMPLETE:
            
            return {
                ...state,
                chatMessageList: [...state.chatMessageList,...action.payload.replyData],
            };

        case homeConstants.HOME_GET_CHATBOT_FAQ_QUESTIONS_COMPLETE:
            return {
                ...state,
                faqList: [...action.payload.faqList],
            };
    
        case homeConstants.GET_PARTICIPANT_JOB_ROLES_COMPLETE:
            return {
                ...state,
                participantJobRoles: [...action.payload.data],
            };

        case homeConstants.GET_DEALER_PARTICIPANT_LIST_COMPLETE:
            return {
                ...state,
                dealerParticipant: [...action.payload.data],
            };
        case homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_COMPLETE:
            return {
                ...state,
                gamePlayDetails: action.payload.data
            }    
        case homeConstants.HOME_GET_NOTIFICATIONS_COMPLETE:
            return {
                ...state,
                notification: action.payload.data
            }
        case homeConstants.HOME_GET_NOTIFICATION_COUNT_COMPLETE:
            return {
                ...state,
                notificationCount: action.payload.data
            }    
    }

    return state;
}
